module.exports = __webpack_public_path__ + "static/media/choithramsDeliveryStore.c9d19832.png";